import type { openrouterModelConfig } from './types';
import { xaiConfigs } from './configs/xai';


/**
 * 模型配置映射
 */
export const openrouterModelConfigs: Record<string, openrouterModelConfig> = {
    ...xaiConfigs,
};
